import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';
import styles from './sass/StakeholderTips.module.scss';

const TipStakeholderFinancialTrigger = () => {
  const { t } = useTranslation();
  return (
    <Tip
      styleTipTextContainer={styles.triggerContainer}
      styleTriangle={styles.triangle}
    >
      <p>
        {t('tipStakeholderFinancialTrigger')}
      </p>
    </Tip>
  );
};

export default TipStakeholderFinancialTrigger;
